import { Injectable } from '@angular/core';
import { PdfRepoService, PdfRequestParamsType, PdfType } from '../../api/pdf-repo/pdf-repo.service';
import { DemoHasAccessService } from '@client/app/modules/demodata/services/demo-has-access.service';
import { DemoPdfDocumentType, DemoPdfRepoService } from '@client/app/modules/demodata/endpoints/demo-pdf-repo/demo-pdf-repo.service';

@Injectable({
    providedIn: 'root',
})
export class PdfService {

    constructor (
        private pdfRepoService: PdfRepoService,
        private demoHasAccessService: DemoHasAccessService,
        private demoPdfRepoService: DemoPdfRepoService) { }

    get (params: PdfRequestParamsType): Promise<PdfType | DemoPdfDocumentType[]> {
        if (this.demoHasAccessService.canAccessAccessibilityPDF()) {
            return this.demoPdfRepoService.get(params);
        }

        return this.pdfRepoService.get(params);
    }

    update (pdf: PdfType | DemoPdfDocumentType, params: PdfRequestParamsType): Promise<void | DemoPdfDocumentType> {
        if (this.demoHasAccessService.canAccessAccessibilityPDF()) {
            return this.demoPdfRepoService.update(pdf as DemoPdfDocumentType, params);
        }

        return this.pdfRepoService.update(pdf as PdfType, params);
    }

    createScan (pdf: PdfType): Promise<PdfType> {
        return this.pdfRepoService.createScan(pdf);
    }

    createRemediation (pdf: PdfType): Promise<void> {
        return this.pdfRepoService.createRemediation(pdf);
    }

    createScanAll (): Promise<void> {
        return this.pdfRepoService.createScanAll();
    }

    markAllPdfsAsReviewed (): Promise<void> {
        return this.pdfRepoService.markAllPdfsAsReviewed();
    }

    requestRemediationQuoteForAllPdfs (): Promise<void> {
        return this.pdfRepoService.requestRemediationQuoteForAllPdfs();
    }
}
